export const graphtypesData = [
  { id: 1, lable: "Random", value: "Random" },
  { id: 2, lable: "Custom", value: "Custom" },
];
export const directiontypesData = [
  { id: 1, lable: "Undirected", value: "Undirected" },
  { id: 2, lable: "Directed", value: "Directed" },
];
export const alpaphat = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "/",
  "[",
  "]",
  "^",
];
